<script setup lang="ts">
useSeo({
  title: `Poker | ${appName()} | Cassino Online | Casa de Apostas`,
});

const { isPokerSectionEnabled } = usePoker();
</script>

<template>
  <section
    v-if="isPokerSectionEnabled"
    :class="$style.playNowSection"
  >
    <BasePokerPlayNow />
  </section>

  <BaseErrorMessage
    v-else
    image-type="error"
    :message="$t('error.page_not_found.message')"
    :subtitle="$t('error.page_not_found.subtitle')"
    :title="$t('error.ops')"
  >
    <button @click="$router.push(localeLink('/'))">
      {{ $t('error.page_not_found.button') }}
    </button>
  </BaseErrorMessage>
</template>

<style module lang="scss">
.playNowSection {
  @apply min-w-full flex justify-center relative mb-5 lg:mb-8;
}
</style>
